import { render, staticRenderFns } from "./PersonInput.vue?vue&type=template&id=348ec578"
import script from "./PersonInput.vue?vue&type=script&lang=js"
export * from "./PersonInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports